<template>
  <img
    v-if="hasImage"
    @error="onError"
    :src="imagePath"
    alt=""
    :width="size"
    :height="size"
    class="-mt-0.5 inline-block max-w-none rounded-full" />
  <svg
    v-else
    :style="svgStyle"
    class="-mt-0.5 inline-block rounded-full">
    <text
      x="50%"
      y="50%"
      text-anchor="middle"
      dominant-baseline="central"
      :style="textStyle">
      {{ initials }}
    </text>
  </svg>
</template>

<script>
import md5 from 'blueimp-md5';

// based on airline brand colors
let colors = [
  '#fcb130',
  '#5c0632',
  '#284094',
  '#d71a21',
  '#009a42',
  '#00645A',
  '#ffbd01',
  '#e60113',
  '#358e9d',
  '#370e62',
  '#be0000',
  '#e60005',
  '#c90000',
  '#0293d0',
  '#c5941b',
  '#e71c23',
  '#000000',
  '#ef2e1f',
  '#00a1e4',
  '#e60111',
  '#08396f',
  '#512698',
  '#0d59a0',
  '#e51820',
  '#002157',
  '#b70131',
  '#001e60',
  '#e32526',
  '#61126b',
  '#d82f2e',
  '#2a5c9a',
  '#003251',
  '#154d9e',
  '#002b5c',
  '#b50029',
  '#89ba16',
  '#e3132c',
  '#00385f',
  '#223367',
  '#2e7d31',
  '#fcd100',
  '#003876',
  '#ff561f',
  '#b5985a',
  '#006b2f',
  '#fe5816',
  '#e52f23',
  '#9b7f4d',
  '#fdcb0a',
  '#dba50f',
];

export default {
  name: 'UserAvatar',
  props: {
    name: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },

    size: {
      type: Number,
      default: 32,
    },
  },

  data() {
    return {
      hasImage: true,
    };
  },

  computed: {
    emailHash() {
      return md5(this.email.trim().toLowerCase());
    },

    imagePath() {
      return `https://www.gravatar.com/avatar/${this.emailHash}?s=${this.size * 2}&d=404`;
    },

    initials() {
      // match spaces and hyphens
      let words = this.name.split(/[\s-]+/);
      let initials = '';

      words.forEach((word) => {
        initials += word.substring(0, 1).toUpperCase();
      });

      // Return only the first two letters regardless
      // of how many initials there are
      return initials.substring(0, 2);
    },

    svgStyle() {
      let firstLetterCode = this.initials.substring(0, 1).charCodeAt() - 64;
      let secondLetterCode = this.initials.substring(1, 2).charCodeAt() - 64;
      let combinedLetterCode = Number.isNaN(secondLetterCode) ? firstLetterCode : firstLetterCode + secondLetterCode;
      let colorIndex = combinedLetterCode % colors.length;

      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        // borderRadius: '100%',
        background: Number.isNaN(colorIndex) ? '#000000' : colors[colorIndex],
      };
    },

    textStyle() {
      return {
        fill: '#fff',
        fontSize: `${this.size * 0.4}px`,
      };
    },
  },

  methods: {
    onError() {
      this.hasImage = false;
    },
  },
};
</script>
